import React, { useState, useEffect, useMemo } from 'react'
import Layout from "../../Component/Layout"
import AsyncSelect from 'react-select/async';
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CharacteristicsModal from '../../Component/CharacteristicsModal ';
import { ORDER_API } from "../../apiConfig";


function Picking() {
    const [salesOrganization, setSalesOrganization] = useState("");
    const [division, setDivision] = useState("");
    const [dChannel, setDChannel] = useState("");
    const [odId, setOdId] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [rfqSummary, setRfqSummary] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [modalData, setModalData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [activeTab, setActiveTab] = useState("product");
    const [selectedBins, setSelectedBins] = useState({});

    // --- NEW: Accordion State ---
    const [expandedOdId, setExpandedOdId] = useState(null);
    const [expandedProductOdId, setExpandedProductOdId] = useState(null);
    const [expandedDocsOdId, setExpandedDocsOdId] = useState(null);
    const [showCharModal, setShowCharModal] = useState(false);
    const [selectedCharData, setSelectedCharData] = useState([]);
    const [storageBins, setStorageBins] = useState([]);

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const res = await fetch(`${ORDER_API}/picking/summary/created`);
                const data = await res.json();
                setRfqSummary(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Failed to load RFQ summary:', err);
            }
        };
        fetchSummary();
    }, []);

    const dropdownOptions = useMemo(() => {
        const getUnique = (key) => [...new Set(rfqSummary.map(item => item[key]).filter(Boolean))];

        return {
            salesOrgs: getUnique('sales_organization'),
            divisions: getUnique('division'),
            channels: getUnique('distribution_channel'),
            customers: getUnique('customer'),
            odIds: getUnique('od_id'),
        };
    }, [rfqSummary]);

    const filteredData = useMemo(() => {
        return rfqSummary.filter((item) => {
            return (
                (salesOrganization === "" || item.sales_organization === salesOrganization) &&
                (division === "" || item.division === division) &&
                (dChannel === "" || item.distribution_channel === dChannel) &&
                (selectedCustomer === "" || item.customer === selectedCustomer) &&
                (odId === "" || item.od_id === odId)
            );
        });
    }, [rfqSummary, salesOrganization, division, dChannel, selectedCustomer, odId]);

    // --- UPDATED: Reset Accordion State on Modal Open ---
    useEffect(() => {
        if (showModal) {
            setActiveTab("product");
            setExpandedOdId(null);
            setExpandedProductOdId(null);
            setExpandedDocsOdId(null);
            setSelectedBins({}); // Clear selections when opening modal
        }
    }, [showModal, modalData]);

    // --- NEW: Toggle Function ---
    const handleToggle = (tab, odId) => {
        if (tab === "basic") setExpandedOdId(prev => prev === odId ? null : odId);
        if (tab === "product") setExpandedProductOdId(prev => prev === odId ? null : odId);
        if (tab === "docs") setExpandedDocsOdId(prev => prev === odId ? null : odId);
    };

    const handleShowCharacteristics = (charData) => {
        let parsedData = [];
        try {
            parsedData = typeof charData === 'string' ? JSON.parse(charData) : charData;
        } catch (e) {
            parsedData = [];
        }
        setSelectedCharData(parsedData || []);
        setShowCharModal(true);
    };

    const handleBinChange = (rowKey, value) => {
        setSelectedBins(prev => ({
            ...prev,
            [rowKey]: value
        }));
    };

    const renderBasicInfoContent = (item) => (
        <div className="row g-3 mt-1">
            <div className="col-md-6">
                <label style={styles.compactLabel}>Outbound Delivery Id</label>
                <div className="form-control form-control-sm" style={styles.compactInput}>{item.od_id}</div>
            </div>
            <div className="col-md-6">
                <label style={styles.compactLabel}>Sales Organization</label>
                <div className="form-control form-control-sm" style={styles.compactInput}>{item.salesOrganization}</div>
            </div>
            <div className="col-md-6">
                <label style={styles.compactLabel}>Division</label>
                <div className="form-control form-control-sm" style={styles.compactInput}>{item.division}</div>
            </div>
            <div className="col-md-6">
                <label style={styles.compactLabel}>Distribution Channel</label>
                <div className="form-control form-control-sm" style={styles.compactInput}>{item.distributionChannel}</div>
            </div>
        </div>
    );

    const renderProductContent = (item) => (
        <div style={{
            ...styles.tableContainer,
            overflowX: 'auto',
            marginTop: '1rem',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            width: '100%'
        }}>
            <table className="table table-hover mb-0" style={{
                ...styles.erpTable,
                width: 'max-content',
                minWidth: '100%',
                tableLayout: 'auto',
                borderCollapse: 'collapse'
            }}>
                <thead>
                    <tr style={{ backgroundColor: '#f8fafc' }}>
                        <th style={{ ...styles.erpTh, textAlign: "center", width: '50px' }}>Item</th>
                        <th style={{ ...styles.erpTh, whiteSpace: "nowrap" }}>SO Id</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Product Code</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Description</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Class</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>UOM</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Quantity</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Req. Date</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap' }}>Del. Qty</th>
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '180px' }}>Batch Number</th>
                        {/* CHANGED: Always show Storage Bin column (removed conditional check) */}
                        <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '120px' }}>Storage Bin</th>
                    </tr>
                </thead>
                <tbody>
                    {item.productDetails?.length === 0 ? (
                        <tr>
                            <td colSpan={11} style={{ ...styles.erpTd, textAlign: "center", padding: '20px' }}>
                                No Products Found
                            </td>
                        </tr>
                    ) : (
                        item.productDetails?.map((prod, idx) => {
                            const rowKey = `${prod.so_id}|${prod.product_code}|${prod.confirmation_qty}|${idx}`;

                            // CHANGED: Use DB value if no local selection is made
                            const currentBin = selectedBins[rowKey] !== undefined
                                ? selectedBins[rowKey]
                                : (prod.storage_bin || "");

                            return (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ ...styles.erpTd, textAlign: "center" }}>{idx + 1}</td>
                                    <td style={styles.erpTd}>{prod.so_id}</td>
                                    <td style={styles.erpTd}>{prod.product_code}</td>
                                    <td style={styles.erpTd}>{prod.description}</td>

                                    <td style={styles.erpTd}>
                                        {prod.product_class}
                                        {prod.characteristics && (
                                            <span
                                                style={{ cursor: 'pointer', marginLeft: '8px', color: '#111111', fontSize: '12px' }}
                                                onClick={() => handleShowCharacteristics(prod.characteristics)}
                                                title="View Characteristics"
                                            >
                                                ▶
                                            </span>
                                        )}
                                    </td>

                                    <td style={styles.erpTd}>{prod.uom}</td>
                                    <td style={styles.erpTd}>{prod.quantity}</td>
                                    <td style={styles.erpTd}>
                                        {/* {prod.requirement_date
                                            ? new Date(prod.requirement_date).toLocaleDateString("en-GB")
                                            : "N/A"} */}
                                        {prod.requirement_date ? (() => {
                                            const d = new Date(prod.requirement_date);
                                            const day = String(d.getDate()).padStart(2, '0');
                                            const month = String(d.getMonth() + 1).padStart(2, '0');
                                            const year = d.getFullYear();
                                            return `${day}/${month}/${year}`;
                                        })() : "N/A"}
                                    </td>
                                    <td style={styles.erpTd}>{prod.delivery_qty}</td>
                                    <td style={styles.erpTd}>{prod.batch_number}</td>

                                    {/* CHANGED: Always show Dropdown (removed conditional check) */}
                                    <td style={styles.erpTd}>{prod.storage_bin}
                                        {/* <select
                                            className="form-control form-control-sm"
                                            value={currentBin}
                                            onChange={(e) => handleBinChange(rowKey, e.target.value)}
                                            style={{
                                                fontSize: '13px',
                                                minWidth: '120px',
                                                height: '30px',
                                                padding: '2px 5px'
                                            }}
                                        >
                                            <option value="">Select Bin</option>
                                            <option value="Store-1">Store-1</option>
                                            <option value="Store-2">Store-2</option>
                                            <option value="Store-3">Store-3</option>
                                        </select> */}
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );

    const renderDocsContent = (item) => (
        <div className="list-group mt-3">
            {item.pdfFilePath && (
                <div className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                        <i className="bi bi-file-earmark-pdf me-2"></i>
                        <span>
                            {item.od_id ? `Delivery Invoice (${item.bi_id})` : "Generated Delivery PDF"}
                        </span>
                    </div>
                    <a
                        href={``}
                        download
                        className="btn btn-sm border"
                    >
                        <i className="bi bi-download me-1"></i> Download
                    </a>
                </div>
            )}

            {item.documents?.map((file, idx) => (
                <div className="list-group-item d-flex justify-content-between align-items-center" key={idx}>
                    <div>
                        <i className="bi bi-file-earmark me-2"></i>
                        <span>{file.file_name}</span>
                    </div>
                    <a
                        href={file.file_url.startsWith('http') ? file.file_url : ``}
                        download
                        className="btn btn-sm border"
                    >
                        <i className="bi bi-download"></i>
                    </a>
                </div>
            ))}

            {!item.pdfFilePath && (!item.documents || item.documents.length === 0) && (
                <div className="list-group-item text-center py-4 text-muted border-0">
                    No documents available.
                </div>
            )}
        </div>
    );

    const handleOpenModal = async () => {
        const firstSelectedCustomer = rfqSummary.find(item => selectedRows.includes(item.od_id))?.customer;

        const allSameCustomer = selectedRows.every(odId => {
            const customer = rfqSummary.find(item => item.od_id === odId)?.customer;
            return customer === firstSelectedCustomer;
        });

        if (!allSameCustomer) { alert("Please select OD IDs of the same customer."); return; }

        const selectedData = rfqSummary.filter(item => selectedRows.includes(item.od_id));
        const od_ids = selectedData.map(item => item.od_id);

        if (od_ids.length > 0) {
            try {
                // Added timestamp to ensure fresh data
                const responses = await Promise.all(od_ids.map(odId =>
                    fetch(`${ORDER_API}/picking/accepted/od/${odId}?t=${Date.now()}`).then(res => res.json())
                ));
                setModalData(responses);
                setModalType('convert');
                setShowModal(true);
            } catch (error) { console.error(error); alert("Error fetching data"); }
        } else { alert("No OD ID selected!"); }
    };

    const handleViewClick = async (od_id) => {
        try {
            // Added timestamp to ensure fresh data
            const res = await fetch(`${ORDER_API}/picking/accepted/od/${od_id}?t=${Date.now()}`);
            const data = await res.json();
            setModalData([data]);
            setModalType('view');
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching RFQ details:", error);
        }
    };

    const handleCheckboxChange = (odId) => {
        setSelectedRows((prev) => {
            const isSelected = prev.includes(odId);
            if (isSelected) return prev.filter(id => id !== odId);

            const selectedItem = rfqSummary.find(item => item.od_id === odId);
            const selectedCust = selectedItem?.customer;

            const firstCust = prev.length > 0
                ? rfqSummary.find(item => item.od_id === prev[0])?.customer
                : null;

            if (firstCust && selectedCust !== firstCust) {
                alert("Please select SO IDs of the same customer.");
                return prev;
            }

            return [...prev, odId];
        });
    };

    const handleSelectAllChange = (checked) => {
        if (checked) {
            const itemsToSelect = filteredData;

            if (itemsToSelect.length === 0) {
                alert("No items found in current view.");
                return;
            }

            const firstCustomer = itemsToSelect[0]?.customer;
            const allSameCustomer = itemsToSelect.every(item => item.customer === firstCustomer);

            if (!allSameCustomer) {
                alert("The items belong to different customers. Please select manually.");
                return;
            }

            setSelectedRows(itemsToSelect.map(item => item.od_id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleCreatePicking = (index = 0) => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        const uniqueSuffix = pad(now.getSeconds()) + pad(index);
        return `PI${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${uniqueSuffix}`;
    };

    // --- NEW: Save Only Bins (For View Mode) ---
    const handleSaveOnlyBins = async () => {
        const updatesPayload = [];

        // Iterate through all items in modalData to find changes
        modalData.forEach(item => {
            item.productDetails?.forEach((prod, idx) => {
                const key = `${prod.so_id}|${prod.product_code}|${prod.confirmation_qty}|${idx}`;
                const selectedBin = selectedBins[key];

                // Add to payload if a bin is selected (and it's different/new)
                if (selectedBin) {
                    updatesPayload.push({
                        id: prod.id,
                        storage_bin: selectedBin
                    });
                }
            });
        });

        if (updatesPayload.length === 0) {
            toast.info("No changes to save.");
            return;
        }

        try {
            const binResponse = await fetch(`${ORDER_API}/picking/save-bins`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: updatesPayload }),
            });

            if (!binResponse.ok) throw new Error("Failed to save storage bins");

            toast.success("Storage bins saved successfully!");

            // Update local modalData so the UI shows the new bins as "saved" (persists if dropdown state cleared)
            const updatedModalData = modalData.map(item => ({
                ...item,
                productDetails: item.productDetails.map((prod, idx) => {
                    const key = `${prod.so_id}|${prod.product_code}|${prod.confirmation_qty}|${idx}`;
                    const newlySelected = selectedBins[key];
                    if (newlySelected) {
                        return { ...prod, storage_bin: newlySelected };
                    }
                    return prod;
                })
            }));

            setModalData(updatedModalData);
            setSelectedBins({}); // Clear dirty state

            // Refresh background list
            const res = await fetch(`${ORDER_API}/picking/summary/created`);
            const data = await res.json();
            setRfqSummary(Array.isArray(data) ? data : []);

        } catch (error) {
            console.error("Error saving bins:", error);
            toast.error("Failed to save bins.");
        }
    };

    const handleSavePicking = async () => {
        if (modalData.length === 0) {
            toast.error("No data found.");
            return;
        }

        const updatesPayload = [];
        modalData.forEach(item => {
            item.productDetails?.forEach((prod, idx) => {
                const key = `${prod.so_id}|${prod.product_code}|${prod.confirmation_qty}|${idx}`;
                const selectedBin = selectedBins[key];

                if (selectedBin) {
                    updatesPayload.push({
                        id: prod.id,
                        storage_bin: selectedBin
                    });
                }
            });
        });

        if (updatesPayload.length === 0) {
            if (!window.confirm("No storage bins selected. Are you sure you want to proceed without assigning bins?")) {
                return;
            }
        }

        try {
            if (updatesPayload.length > 0) {
                const binResponse = await fetch(`${ORDER_API}/picking/save-bins`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ updates: updatesPayload }),
                });

                if (!binResponse.ok) {
                    throw new Error("Failed to save storage bins");
                }
            }

            const uniqueOdIds = [...new Set(modalData.map(item => item.od_id))];

            const pickingMappings = uniqueOdIds.map((odId, index) => ({
                od_id: odId,
                pi_id: handleCreatePicking(index)
            }));

            const response = await fetch(`${ORDER_API}/picking/finalize-picking`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    mappings: pickingMappings
                }),
            });

            const data = await response.json();

            if (response.ok) {
                const generatedIds = pickingMappings.map(m => m.pi_id).join(', ');
                toast.success(`Picking IDs created: ${generatedIds}`);
                setShowModal(false);
                window.location.reload();
            } else {
                toast.error(`Error: ${data.message}`);
            }
        } catch (error) {
            console.error("Error finalizing picking:", error);
            toast.error("An error occurred while creating picking: " + error.message);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedRows([]);
        setSelectedBins({});
    };

    const handleDownloadPdf = (odId) => {
        // Assuming your backend serves PDFs at this path (same as Outbound Delivery)
        const pdfUrl = ``;

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.setAttribute('download', `${odId}.pdf`); // Force download
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Layout>
            <div style={styles.pageTitleBar}>
                <div>
                    <div style={styles.pageTitle}>Picking</div>
                    <div style={styles.pageSubtitle}>Manage and view your data here</div>
                </div>
                <button className="btn btn-dark" style={styles.primaryBtn} onClick={handleOpenModal}>
                    + Confirm Picking
                </button>
            </div>

            <div style={styles.filterCard}>
                <div className="row g-4">
                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Sales Organization</label>
                        <select
                            className="form-control"
                            style={styles.filterSelect}
                            value={salesOrganization}
                            onChange={(e) => setSalesOrganization(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.salesOrgs.map((org) => (
                                <option key={org} value={org}>{org}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Division</label>
                        <select
                            className="form-control"
                            style={styles.filterSelect}
                            value={division}
                            onChange={(e) => setDivision(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.divisions.map((div) => (
                                <option key={div} value={div}>{div}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>Distribution Channel</label>
                        <select className="form-control"
                            style={styles.filterSelect}
                            value={dChannel}
                            onChange={(e) => setDChannel(e.target.value)}>
                            <option value="">Select</option>
                            {dropdownOptions.channels.map((chan) => (
                                <option key={chan} value={chan}>{chan}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2 col-sm-4">
                        <label style={styles.filterLabel}>OD ID</label>
                        <select
                            className="form-control"
                            style={styles.filterSelect}
                            value={odId}
                            onChange={(e) => setOdId(e.target.value)}
                        >
                            <option value="">select</option>
                            {dropdownOptions.odIds.map((id) => (
                                <option key={id} value={id}>{id}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4 col-sm-12">
                        <label style={styles.filterLabel}>Customer</label>
                        <select
                            className="form-control"
                            style={styles.filterSelect}
                            value={selectedCustomer}
                            onChange={(e) => setSelectedCustomer(e.target.value)}
                        >
                            <option value="">Select</option>
                            {dropdownOptions.customers.map((cust) => (
                                <option key={cust} value={cust}>{cust}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div style={styles.tableContainer}>
                <table className="table" style={styles.erpTable}>
                    <thead>
                        <tr>
                            <th style={{ ...styles.erpTh, width: 50, textAlign: "center" }}>
                                <input
                                    type="checkbox"
                                    checked={filteredData.length > 0 && selectedRows.length > 0 && filteredData.every(item => selectedRows.includes(item.od_id))}
                                    onChange={(e) => handleSelectAllChange(e.target.checked)}
                                />
                            </th>
                            <th style={{ ...styles.erpTh, width: 150 }}>OD ID</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Customer</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Total Price</th>
                            <th style={{ ...styles.erpTh, width: 150 }}>Status</th>
                            <th style={{ ...styles.erpTh, width: 100 }}></th>
                            <th style={{ ...styles.erpTh, width: 100, textAlign: "center" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="9" style={{ ...styles.erpTh, textAlign: "center" }}>
                                    No Records Found
                                </td>
                            </tr>
                        ) : (
                            filteredData.map((item) => (
                                <tr
                                    key={item.od_id}
                                    style={{
                                        backgroundColor: item.status === 'approved' ? "#f2f2f2" : "white",
                                        opacity: item.status === 'approved' ? 0.6 : 1
                                    }}
                                >
                                    <td style={{ ...styles.erpTh, width: 50, textAlign: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(item.od_id)}
                                            onChange={() => handleCheckboxChange(item.od_id)}
                                        />
                                    </td>
                                    <td style={styles.erpTd}>{item.od_id || ""}</td>
                                    <td style={styles.erpTd}>{item.customer || ""}</td>
                                    <td style={styles.erpTd}>{item.total_price}</td>
                                    <td style={styles.erpTd}>{item.status}</td>
                                    <td style={styles.erpTd}>
                                        <button
                                            className="btn btn-outline-dark btn-sm"
                                            onClick={() => handleViewClick(item.od_id)}
                                        >
                                            View
                                        </button>
                                    </td>
                                    <td style={{ ...styles.erpTd, textAlign: "center" }}>
                                        <div
                                            onClick={() => handleDownloadPdf(item.od_id)}
                                            title="Download PDF"
                                            style={{
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%"
                                            }}
                                        >
                                            {/* Red Download Icon SVG */}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#0e0e0e" viewBox="0 0 16 16">
                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                            </svg>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* --- MODAL --- */}
            {showModal && modalData.length > 0 && (
                <div style={styles.modalBackdrop}>
                    <div style={{ ...styles.modal, maxWidth: "1200px", width: "90%", maxHeight: "90vh" }}>

                        <div style={styles.modalHeader}>
                            <div style={{ fontWeight: 600, fontSize: '1.2rem' }}>
                                {/* Updated Header Logic */}
                                {modalType === 'convert' ? 'Picking ' : `Picking : ${modalData[0]?.od_id}`}
                            </div>
                            <button style={styles.iconBtn} onClick={handleCloseModal}>✕</button>
                        </div>

                        <div style={styles.modalBody}>

                            <div className="mt-3 p-3" style={{ border: '1px solid #e2e8f0', borderRadius: '8px', backgroundColor: '#ffffff' }}>
                                {/* Existing Customer Row */}
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <label className="form-label fw-bold mb-2" style={{ fontSize: '14px', color: '#1e293b' }}>Customer</label>
                                        <div className="form-control d-flex align-items-center justify-content-between"
                                            style={{ minHeight: '42px', fontSize: '14px', color: '#64748b', backgroundColor: '#f8fafc', border: '1px solid #000000', borderRadius: '6px', cursor: 'default', padding: '0 12px' }}>
                                            <span>{modalData[0]?.customer || "N/A"}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Partner Details */}
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#1e293b' }}>Shipping Address</label>
                                        <div className="p-2" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', minHeight: '38px', color: '#475569' }}>
                                            {modalData[0]?.registeredAddress || "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#1e293b' }}>Billing Address</label>
                                        <div className="p-2" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', minHeight: '38px', color: '#475569' }}>
                                            {modalData[0]?.communicationAddress || "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-bold mb-1" style={{ fontSize: '13px', color: '#1e293b' }}>Payment Terms</label>
                                        <div className="p-2" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px', minHeight: '38px', color: '#475569' }}>
                                            {modalData[0]?.paymentTerms || "N/A"}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...styles.tabs, marginBottom: "10px" }}>
                                <button className={`btn ${activeTab === "product" ? "btn-secondary" : "btn-light"}`} onClick={() => setActiveTab("product")} style={styles.compactTabBtn}>Product</button>
                                <button className={`btn ${activeTab === "docs" ? "btn-secondary" : "btn-light"}`} onClick={() => setActiveTab("docs")}>Documents</button>
                            </div>

                            {activeTab === "product" && (
                                <div>
                                    {modalData.map((item) => (
                                        <div key={`${item.od_id}-product`} style={{ marginBottom: "15px" }}>
                                            {modalType === 'view' ? (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fff" }}>
                                                    {renderProductContent(item)}
                                                </div>
                                            ) : (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }} onClick={() => handleToggle("product", item.od_id)}>
                                                        <h6 style={{ margin: 0 }}>{item.od_id}</h6>
                                                        <i className={`bi bi-chevron-${expandedProductOdId === item.od_id ? "down" : "right"}`} style={{ fontSize: "18px" }}></i>
                                                    </div>
                                                    {expandedProductOdId === item.od_id && renderProductContent(item)}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {activeTab === "docs" && (
                                <div>
                                    {modalData.map((item) => (
                                        <div key={`${item.od_id}-docs`} style={{ marginBottom: "15px" }}>
                                            {modalType === 'view' ? (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fff" }}>
                                                    {renderDocsContent(item)}
                                                </div>
                                            ) : (
                                                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }} onClick={() => handleToggle("docs", item.od_id)}>
                                                        <h6 style={{ margin: 0 }}>{item.od_id}</h6>
                                                        <i className={`bi bi-chevron-${expandedDocsOdId === item.od_id ? "down" : "right"}`} style={{ fontSize: "18px" }}></i>
                                                    </div>
                                                    {expandedDocsOdId === item.od_id && renderDocsContent(item)}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div style={styles.modalFooter}>
                            {/* CHANGED: Added Save Button for View Mode */}
                            {/* {modalType === 'view' && (
                                <button
                                    className="btn btn-dark"
                                    onClick={handleSaveOnlyBins}
                                >
                                    Save
                                </button>
                            )} */}
                            <button className="btn btn-outline-secondary" onClick={handleCloseModal}>Close</button>
                            {modalType === 'convert' && (<button className="btn btn-dark" onClick={handleSavePicking}>Save</button>)}
                        </div>

                    </div>
                </div>
            )}
            <CharacteristicsModal
                modalVisible={showCharModal}
                handleClose={() => setShowCharModal(false)}
                selectedCharacteristics={selectedCharData}
                isEditing={false}
            />
            <ToastContainer position="top-right" autoClose={3000} />
        </Layout>
    );
}

const styles = {
    compactLabel: { fontSize: "14px", fontWeight: 600, marginBottom: "4px" },
    compactInput: { fontSize: "14px", height: "32px", padding: "4px 8px" },
    compactTabBtn: { fontSize: "14px", padding: "4px 10px" },
    tableContainer: { background: "#ffffff", borderRadius: 8, padding: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    erpTable: { width: "100%", tableLayout: "auto", borderCollapse: "collapse" },
    erpTh: { background: "#f8fafc", fontSize: 13, fontWeight: 600, padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#1e293b", whiteSpace: "nowrap" },
    erpTd: { fontSize: 13, padding: "10px 12px", borderBottom: "1px solid #f1f5f9", color: "#334155", verticalAlign: "middle" },
    filterCard: { background: '#ffffff', borderRadius: 8, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 18 },
    filterLabel: { fontSize: 13, fontWeight: 600, marginBottom: 6, color: '#334155' },
    filterSelect: { height: 36, fontSize: 13 },
    pageTitleBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
    pageTitle: { fontSize: 26, fontWeight: 700, color: '#1e293b', marginBottom: 2 },
    pageSubtitle: { fontSize: 13, color: '#64748b' },
    primaryBtn: { paddingLeft: 14, paddingRight: 14 },
    modalBackdrop: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050, padding: '20px' },
    modal: { background: '#fff', borderRadius: '8px', width: '90%', maxWidth: '1200px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    modalHeader: { padding: '15px 20px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    iconBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer' },
    modalBody: { padding: '20px', overflowY: 'auto', flex: 1 },
    modalFooter: { padding: '15px 20px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end', gap: '10px' },
    tabs: { display: 'flex', gap: 8, margin: '14px 0' },
};

export default Picking;